import useCancelOrder from '@activities/order/CancelOrderModal/hooks/useCancelOrder';
import AppModal from '@components/AppModal';
import Text from '@components/Text';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

interface Params {
    orderNo: string;
}

declare module '@stackflow/config' {
    interface Register {
        CancelOrderModal: Params;
    }
}

const CancelOrderModal: ActivityComponentType<'CancelOrderModal'> = ({ params }) => {
    const { t } = useTranslation('orderLog');
    const { orderNo } = params;
    const cancelOrder = useCancelOrder(orderNo);
    return (
        <AppModal title={t('cancelModal.title')}
            deny={t('cancelModal.cancel')}
            confirm={t('cancelModal.confirm')}
            onConfirm={cancelOrder} >
            <Text size='title' align='center'>{t('cancelModal.message')}</Text>
        </AppModal>
    );
};

export default CancelOrderModal;
